import { Container } from '@mui/material'
import ArchivedList from './Components/ArchivedList/ArchivedList'
import AddNewArchive from '../../../components/AddNewArchive/AddNewArchive'

const AdminArchive = () => {
  return (
    <>
      <Container>
        <AddNewArchive />
        <ArchivedList />
      </Container>
    </>
  )
}

export default AdminArchive
